<ng-container *ngIf="template | async">
    <div class="popup-background" (click)="closePopup()"></div>
    <div class="popup-content">
        <ng-container [ngTemplateOutlet]="template | async"></ng-container>
    </div>
</ng-container>
